function ThankYou() {
  

  const handleClose = () => {
    window.location.href = "/dashboard"
  };

  

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 text-[#232323]">
      <div className="w-full max-w-md text-center space-y-6">
        <h1 className="text-4xl font-bold">Thank you!</h1>
        
        <p className="text-gray-600 text-lg">
        Your Premium Package has been activated!
        </p>

        <button
          onClick={handleClose}
          className="w-full py-3 px-4 text-white bg-primary hover:bg-secondary font-medium rounded-full transition-colors duration-200"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}

export default ThankYou;